export { format, label };

/**
 * format
 *
 * returns a comma-separated price
 * @param {integer} amount
 * @returns {string}
 */
function format(amount) {
  return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * label
 *
 * returns a comma-separated integer w/ a label
 * @param amount
 * @param labelStr
 * @param zeroStr
 * @returns {*}
 */
function label(amount, labelStr, zeroStr) {
  if (amount === 0) {
    return zeroStr;
  }
  if (amount > 0) {
    return `${format(amount)} ${labelStr}`;
  }

  return '';
}
